import React, { useState, useEffect } from 'react';
import { Constants } from '../../Constants';

const EnterCreditCardDetailsSection = (props) =>{
    const [cardPassesLuhnCheck,updateLuhnCheck] = useState(true);
    const [cardHasExpired,updateCardHasExpired] = useState(false);
    const [cardExpiryDate,updateCardExpiryDate] = useState({"month": null,"year": null});

    const checkIfCardHasExpiredBasedOnUserInput = () => {
        if(cardExpiryDate.month === null || cardExpiryDate.year === null){
            return false;
        }
        if(Number(cardExpiryDate.year) <= (new Date()).getFullYear()){
            if(Number(cardExpiryDate.month) < (new Date()).getMonth()){
                return (true);
            }
        }
        return (false);
    }

    useEffect(() => {
        updateCardHasExpired(checkIfCardHasExpiredBasedOnUserInput());
    },[cardExpiryDate]);

    const luhnCheck = value => {
        // let arr = (num + '')
        //   .split('')
        //   .reverse()
        //   .map(x => parseInt(x));
        // let lastDigit = arr.splice(0, 1)[0];
        // let sum = arr.reduce((acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val * 2) % 9) || 9), 0);
        // sum += lastDigit;
		// return sum % 10 === 0;
		// accept only digits, dashes or spaces
		//https://gist.github.com/DiegoSalazar/4075533
		if (/[^0-9-\s]+/.test(value)) return false;

		// The Luhn Algorithm. It's so pretty.
		var nCheck = 0, nDigit = 0, bEven = false;
		value = value.replace(/\D/g, "");
	
		for (var n = value.length - 1; n >= 0; n--) {
			var cDigit = value.charAt(n),
				nDigit = parseInt(cDigit, 10);
	
			if (bEven) {
				if ((nDigit *= 2) > 9) nDigit -= 9;
			}
	
			nCheck += nDigit;
			bEven = !bEven;
		}
	
		return (nCheck % 10) == 0;
      };

    
    
    const onCreditCardNumChange = evt => {
        var stringLength = evt.target.value.length;
        if(stringLength === 19){                            
            var cardNumberValue = evt.target.value.replaceAll('-','');
            cardNumberValue = cardNumberValue.replaceAll(' ','');
            updateLuhnCheck(luhnCheck(cardNumberValue));
        }else{
            updateLuhnCheck(true);
        }
        var index = evt.target.value.lastIndexOf('-');
        var test = evt.target.value.substr(index + 1);
        if (test.length === 4){
            if(evt.key === "Backspace" || evt.key === "Delete" || evt.target.value.length === 19){

            }else{
                evt.target.value = evt.target.value + "-";
            }
        }else if(test.length === 5){
            if(evt.target.value[stringLength - 1] != "-"){
                var lastCharacter = evt.target.value[stringLength-1];
                var newValue = evt.target.value;
                newValue = newValue.concat(lastCharacter);
                // newValue[newValue.length - 1] = "-"; strings are immutable
                newValue = newValue.substring(0, stringLength - 1) + '-' + newValue.substring(stringLength);
                evt.target.value = newValue; 
            }
        }
    };
    
    var currentYear = new Date().getFullYear();
    //https://stackoverflow.com/questions/2500588/maximum-year-in-expiry-date-of-credit-card
    var years = [...Array(75).keys()];
    return (
        <div className="row m-1 p-1">
            <div className="col-sm-12 col-md-6 p-2">
                <div className="card border border-muted p-2">
                    {/* Max and min lenghts and other validation elements specified at https://api.authorize.net/xml/v1/schema/AnetApiSchema.xsd 
                    Check the asp.net core backend for details about mapping, validation is duplicated on the backend */}
                    <h3>Billing Address</h3>
                    <label className="control-label"  htmlFor="fname"><i className="fa fa-user" style={{"color": "grey"}}></i> First Name</label>
                    <input className="form-control mb-1" type="text" id="fname" name="firstName" required maxLength={50} autoComplete="given-name"/>
                    <label className="control-label"  htmlFor="lname"> Last Name</label>
                    <input className="form-control mb-1" type="text" id="lname" name="lastName" required maxLength={50} autoComplete="family-name"/>
                    <label className="control-label"  htmlFor="company"> Company Name <span className="text-muted">(Optional)</span></label>
                    <input className="form-control mb-1" type="text" id="company" name="company" maxLength={50} autoComplete="organization" />
                    <label className="control-label"  htmlFor="billingEmail"><i className="fa fa-envelope" style={{"color":"grey"}}></i> Email <em>(Payment receipt sent here)</em></label>
                    <input type="email" className="form-control mb-1" type="text" id="billingEmail" name="email" required maxLength={255} autoComplete="email"/>
                    <label className="control-label"  htmlFor="adr"><i className="fa fa-address-card-o" style={{"color":"grey"}}></i> Address</label>
                    <input className="form-control mb-1" type="text" id="adr" name="address" required maxLength={60} autoComplete="street-address"/>
                    <label className="control-label ml-1"  htmlFor="city"><i className="fa fa-institution" style={{"color":"grey"}}></i> City</label>
                    <input className="form-control mb-1" type="text" id="city" name="city" required maxLength={40} placeholder=""/>
                    <div className="row">
                        <div className="col-6">
                            <label className="control-label"  htmlFor="state">State</label>
                            <select className="form-select mb-1" type="text" id="state" name="state" required maxLength={40}>
                                {Constants.unitedStatesList.map(
                                    (val, index) => <option key={index} value={val}>{val}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-6">
                            <label className="control-label"  htmlFor="zip">Zip</label>
                            <input className="form-control ml-1" type="text" id="zip" name="zip" required maxLength={20} autoComplete="postal-code"/>
                        </div>
                    </div>
                    <label className="control-label" htmlFor="country">Country</label>
                    <input className="form-control readOnly ml-1" readOnly value="United States" type="text" id="country" 
                        name="country" required maxLength={60}/>
                </div>
            </div>
            {/* 4417 1234 5678 9113 
                4111-1111-1111-1111
            */}
            <div className="col-sm-12 col-md-6 p-2">
                <h3>Card details</h3>
                <label className="control-label" htmlFor="cname">Name on Card</label>
                <input className="form-control" type="text" id="cname" name="cardname" required maxLength={150} autoComplete="cc-name"/>
                <label className="control-label" htmlFor="ccnum">Credit card number</label>
                <input className="form-control text-dark" type="text" id="ccnum" name="cardnumber" 
                    required minLength={4} maxLength={19} autoComplete="cc-number"
                    onKeyDown={(evt) => onCreditCardNumChange(evt)}
                    onBlur={(evt) => onCreditCardNumChange(evt)}
                    />
                <span className="text-danger" hidden={cardPassesLuhnCheck}>Invalid credit card number</span> 
                <div className="row">
                    <div className="col-6">
                        <label className="control-label"  htmlFor="expyear">Expiry Year</label>
                        <select className="form-select" type="number" id="expyear" name="expyear" required autoComplete="cc-exp-year"
                        onChange={(evt) =>{
                            //https://stackoverflow.com/questions/47442839/inputs-event-target-is-null-within-this-setstate-react-js
                            var value = evt.target.value;
                            updateCardExpiryDate(prev => ({ "month" : prev.month, "year" : value }));
                        }}>
                                {/* onChange={(evt) =>{
                                updateCardExpiryDate(prev => { prev.year = evt.currentTarget.value; return prev;});
                                evt.stopPropagation();
                                updateCardHasExpired(checkIfCardHasExpiredBasedOnUserInput());
                        }} */}
                            <option>- Select</option>
                            {years.map(
                                index => <option key={index} value={index + currentYear}>{index + currentYear}</option>
                            )}
                        </select>
                    </div>
                    <div className="col-6">
                        <label className="control-label"  htmlFor="expmonth">Expiry Month</label>
                        <select className="form-select" type="number" id="expmonth" name="expmonth" required min={1} max={12}
                            autoComplete="cc-exp-month"
                            onChange={(evt) =>{
                                var value = evt.target.value;
                                updateCardExpiryDate(prev => ({ "month" : value, "year" : prev.year }));
                                }}>
                                 {/* onChange={(evt) =>{
                                updateCardExpiryDate(prev => { prev.month = evt.currentTarget.value; return prev;});
                        }} */}
                            <option>- Select</option>
                            <option value={1}>01 - January</option>
                            <option value={2}>02 - February</option>
                            <option value={3}>03 - March</option>
                            <option value={4}>04 - April</option>
                            <option value={5}>05 - May</option>
                            <option value={6}>06 - June</option>
                            <option value={7}>07 - July</option>
                            <option value={8}>08 - August</option>
                            <option value={9}>09 - September</option>
                            <option value={10}>10 - October</option>
                            <option value={11}>11 - November</option>
                            <option value={12}>12 - December</option>
                        </select>
                    </div>
                    {cardHasExpired && <div className="col-12 text-danger">Card has expired</div>}
                    <div className="col-4">
                        <label className="control-label"  htmlFor="cvv">CVV / CCV</label>
                        <input className="form-control" type="text" id="cvv" name="cvv" required minLength={3} maxLength={4} autoComplete="cc-csc"/>
                    </div>
                </div>  

                <div className="icon-container my-2">
                    <i className="fa fa-cc-visa mr-1" style={{"color":"navy"}}></i> 
                    <i className="fa fa-cc-amex mr-1" style={{"color":"blue"}}></i>
                    <i className="fa fa-cc-mastercard mr-1" style={{"color":"red"}}></i>
                    <i className="fa fa-cc-discover mr-1" style={{"color":"orange"}}></i>
                    <i className="fa fa-cc-jcb mr-1"></i>                   
                </div>
            </div>
            
        </div>
    )
}
export { EnterCreditCardDetailsSection }; 